<ng-container>
  <div class="search-part">
    <div class="search-input-row">
      <input
        class="form-control custom-input"
        placeholder="Rechercher acte optique..."
        autocomplete="off"
        [(ngModel)]="searchText"
        (keyup)="getItems()"
        type="text"
        [disabled]="disabledItem"
      >
      <button
        *ngIf="searchText || itemSelected?.id"
        type="button"
        class="btn-clear"
        (click)="reinitValue()"
        [disabled]="disabledItem"
        title="Vider"
      >
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="search-results" *ngIf="canDisplay">
      <div class="search-results-header">
        <div class="status-legend">
          <span class="legend-item"><span class="legend-dot excluded"></span>Exclu</span>
          <span class="legend-item"><span class="legend-dot prior-agreement"></span>Entente préalable</span>
          <span class="legend-item"><span class="legend-dot available"></span>Disponible</span>
        </div>
        Actes optiques
      </div>
      <div class="medications-container" (scroll)="onScroll($event)">
        <div
          *ngFor="let item of listItem; let i = index"
          class="medication-item"
          [ngClass]="getMedicationStatusClass(item)"
          (click)="selectItem(item)"
        >
          <div class="item-number">{{ i + 1 }}</div>
          <div class="item-content" [innerHTML]="item.styled"></div>
          <div class="status-indicator"></div>
        </div>
        <div *ngIf="!listItem.length" class="no-data">
          <i class="fa fa-search"></i>
          <span>Aucun acte trouvé</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
